<template>
  <div v-if="info && info.length" style="position: relative; width: 100%; height: 100%;">
    <p style="position: absolute; width: 100%; text-align: center; padding: 0; margin: 35px 0 0 -15px;">Failures (Total: {{ totalFailures }})</p>
    <div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: space-around;">
      <div style="height: 340px; width: 400px; margin-top: -30px; margin-left: 0">
        <canvas id="failuremodechart"></canvas> 
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js/auto'

export default { 
  props: {
    info: {
      type: Array,
      default: () => []
      /*[
          {
              "A reason": 1
          },
          {
              "Another reason": 3
          },
          {
              "One extra reason": 2
          }
      ]
          */
    }
  },

  data () {
    return {
      chart: false
    }
  },

  mounted () {
   this.buildChart()
  },

  watch: {
    info() {
      this.$nextTick(() => {
        this.buildChart()
      })
    }
  },

  computed: {
    totalFailures () {
      return Object.values(this.chartData).reduce((total, item) => {
        return total += item.value
      }, 0)
    },
    // chart data
    chartData () {
      return this.info.reduce((set, item) => {
        let failureReason = Object.keys(item)
        // we want to add the value to the key that we show beside the chart too, so we make a string val of it here :) 
        let key = `${failureReason[0]} (${item[failureReason[0]]})`
        set[key] = {
          value: item[failureReason[0]],
          reason: failureReason[0]
        }
        return set
      }, {})
    }
  },

  methods: {
    buildChart () {
      const labels = Object.keys(this.chartData)

      const GetColor = (label) => {
        let colors = {
          'authentication failure': '#ED7D31',
          'file not found': '#4472C4',
          'too many retries': '#A5A5A5',
          'out of memory': '#FFC000',
          'abandoned': '#5B9BD5',
          'aborted': '#70AD47',
        }

        return colors[label.toLowerCase()] || '#a02b93'
      }
      

      const data = {
        labels: labels,
        datasets: [
          {
            label: 'Device count',
            data: Object.values(this.chartData).map(i => i.value),
            // these are just some random colors, could probably do with making colors for specific status values when we can :) 
            backgroundColor: labels.map(i => GetColor(this.chartData[i].reason)),
            hoverOffset: 4
          }
        ]
      }

      // legend shown on the right instead of below as per the docs, doesn't seem like chart.js has a horizontal setting for the legend and 
      // displaying a downward list below the chart is horrible for spacing >:(
      const config = {
        height: '100%',
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            labels: {
              color: 'rgba(0,0,0,0.6)'
            }
          }
        }
      }

      if (this.chart) {
        this.chart.destroy()
      }

      this.chart = new Chart(
      document.getElementById('failuremodechart'), {
        type: 'pie', 
        data: data,
        options: config
      })
    }
  }
}
</script>